import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { analytics, logEvent, setUserId } from "../firebase";
import { auth } from "../firebase";

export default function RouteAnalytics() {
  const location = useLocation();

  useEffect(() => {
    const user = auth.currentUser;
    if (user) {
      // Set the persistent user ID
      setUserId(analytics, user.uid);
    }

    // Log page view with custom properties
    logEvent(analytics, "page_view", {
      page_path: location.pathname,
      page_title: document.title || location.pathname,
      page_uid: user?.uid || "anonymous", // custom property
      page_timestamp: Date.now(), // custom property
    });
  }, [location]);

  return null;
}
